module.exports = __webpack_public_path__ + "static/media/jquery.9999c1a8.gif";